import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
import { BackButton } from '@membershipForm/components/QuestionHeader/styles';
export const Wrapper = styled.form `
  color: white;
  position: relative;
  overflow: hidden;

  ${BackButton} {
    left: -2rem;
  }
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    ${BackButton} {
      left: 1.5rem;
      top: -0.5rem;
    }
  }
`;
export const Header = styled.div `
  margin-bottom: 3rem;
`;
export const Title = styled.span `
  font: var(--heading-two-font);
  margin-bottom: 0;
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    max-width: 25rem;
    display: inline-block;
  }
`;
export const SubTitle = styled.span `
  margin-bottom: 0;
  color: white;
`;
export const SmallContainer = styled.div `
  width: 37.5rem;
  padding: 0 2rem;
  margin: 0 auto;
  text-align: center;
  z-index: 2;
  position: relative;
`;
export const Background = styled.div `
  position: absolute;
  z-index: 1;
  width: 100%;
  overflow: hidden;
  background-image: var(--scratch-bg);
  height: 36rem;
  top: 0;
  background-size: cover;
  background-position: left bottom;
  max-width: 135rem;
  left: 50%;
  transform: translateX(-50%);
  
  #fitness-page & {
    background-image: url("assets/images/scratch-background--grey.png");
  }
  
  
  @media screen and (max-width: ${MediaSizes.MD_MAX}px) {
    height: 25.5rem;
    top: -3rem;
    background-position: left center;
    background-size: calc(100% + 8rem);
  }
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    height: 25rem;
  }
`;
export default {
    Wrapper,
    Header,
    Title,
    SubTitle,
    SmallContainer,
};
